module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "planBuilderInteraction": {
    "name": "plan-builder-interaction",
    "class": "interaction",
    "properties": {
      "component": "string",
      "action": "string",
      "skuId": {
        "type": "number",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "currency": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "selectCurrency": {
    "name": "select-currency",
    "class": "interaction",
    "properties": {
      "currency": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "termSelectorInteraction": {
    "name": "term-selector-interaction",
    "class": "interaction",
    "properties": {
      "term": "string",
      "action": "string",
      "trackingSource": "string",
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "discountShown": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "scrollInteraction": {
    "name": "scroll-interaction",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "action": "string",
      "apiName": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "additionalUnitsPicker": {
    "name": "additional-units-picker",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "ownsProduct": {
        "type": "boolean",
        "isOptional": true
      },
      "skuId": "number",
      "ownedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "displayedUnitQuantity": "number",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "clickToViewModal": {
    "name": "click-to-view-modal",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "faqInteraction": {
    "name": "faq-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "questionKey": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "modalInteraction": {
    "name": "modal-interaction",
    "class": "interaction",
    "properties": {
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "modalName": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "externalLinkClick": {
    "name": "external-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "internalLinkClick": {
    "name": "internal-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "fromTab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "toTab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "bannerInteraction": {
    "name": "banner-interaction",
    "class": "interaction",
    "properties": {
      "name": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "compareToolInteraction": {
    "name": "compare-tool-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "added product",
        "removed product",
        "updated product",
        "viewed features",
        "clicked compare button"
      ],
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "updatedProduct": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "featureTableInteraction": {
    "name": "feature-table-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-expand-all-sections",
        "clicked-expand-section",
        "clicked-expand-table",
        "clicked-collapse-all-sections",
        "clicked-collapse-section",
        "clicked-collapse-table"
      ],
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "products": {
        "type": "array",
        "isOptional": true
      },
      "currentPlan": {
        "type": "string",
        "isOptional": true
      },
      "recommendedPlan": {
        "type": "string",
        "isOptional": true
      },
      "showRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": "string",
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "communicationMethodsInteraction": {
    "name": "communication-methods-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "chat-shown",
        "chat-conversation-started",
        "phone-element-shown",
        "phone-element-clicked"
      ],
      "phoneNumber": {
        "type": "string",
        "isOptional": true
      },
      "phoneSourceId": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "phoneNumberClick": {
    "name": "phone-number-click",
    "class": "interaction",
    "properties": {
      "phoneNumber": "string",
      "phoneSourceId": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "linkClick": {
    "name": "link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "trackingSource": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "conversations": {
    "name": "conversations",
    "class": "interaction",
    "properties": {
      "action": [
        "conversation-started",
        "clicked-chat-with-sales"
      ],
      "formattedExperimentArray": {
        "type": "array",
        "isOptional": true
      },
      "conversationId": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "limitInteraction": {
    "name": "interaction",
    "properties": {
      "action": [
        "clicked to expand limit cards section",
        "clicked to collapse limit cards section"
      ]
    },
    "namespace": "pricing-pages-ui-components",
    "class": "interaction"
  },
  "upgradesInteraction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "upgradeKey": {
        "type": "string",
        "isOptional": true
      },
      "apiName": {
        "type": "string",
        "isOptional": true
      },
      "features": {
        "type": "array",
        "isOptional": true
      },
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "pointType": {
        "type": "string",
        "isOptional": true
      },
      "app": {
        "type": "string",
        "isOptional": true
      },
      "upgradeSource": {
        "type": "string"
      }
    },
    "namespace": "upgrades"
  },
  "additional-units-picker": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "stepper increase",
        "stepper decrease"
      ],
      "skuId": "number",
      "displayedUnitQuantity": "number",
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "ownsProduct": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "clicked-link": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked link"
      ],
      "type": [
        "internal",
        "external"
      ],
      "url": "string",
      "name": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "modal-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click to open",
        "click to close",
        "click to add",
        "viewed"
      ],
      "name": "string",
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "ownedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "displayedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "navigation-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click next",
        "click back"
      ],
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "talk-to-sales-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click talk to sales"
      ],
      "flow": {
        "type": "string",
        "isOptional": false
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "skuId": {
        "type": "number",
        "isOptional": true
      },
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthprofessional",
          "growthenterprise",
          "bundle",
          "marketingstartercms",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string",
        "isOptional": true
      },
      "hubsSignupCta": {
        "type": "string",
        "isOptional": true
      },
      "upgradeProduct": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "buy-button-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "purchaseMotion": "string",
      "productNames": {
        "type": "array",
        "isOptional": false
      },
      "trackingSource": {
        "type": "string",
        "isOptional": false
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "nonMerchandiseIdProduct": {
        "type": "string",
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string",
        "isOptional": true
      },
      "hubsSignupCta": {
        "type": "string",
        "isOptional": true
      },
      "upgradeProduct": {
        "type": "string",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "product-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "select onboarding",
        "select hub"
      ],
      "productName": {
        "type": "string",
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "button-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click button"
      ],
      "value": {
        "type": "string",
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "scroll-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "faq-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "opened",
        "closed"
      ],
      "value": {
        "type": "string",
        "isOptional": false
      },
      "questionKey": {
        "type": "string",
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "hover-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "value": "string",
      "trackingSource": {
        "type": "string",
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "banner-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click",
        "view",
        "dismiss"
      ],
      "name": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "currency-picker-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "currency": "string",
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "term-selector-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "view",
        "click"
      ],
      "term": "string",
      "paymentTerm": {
        "type": "string",
        "isOptional": true
      },
      "commitTerm": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": "string",
      "discountShown": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "communication-methods-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "chat-conversation-loaded",
        "chat-conversation-started",
        "phone-element-shown",
        "phone-element-clicked",
        "phone-number-clicked"
      ],
      "trackingSource": {
        "type": "string",
        "isOptional": false
      },
      "phoneNumber": {
        "type": "string",
        "isOptional": true
      },
      "formattedExperimentArray": {
        "type": "array",
        "isOptional": true
      },
      "conversationId": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "plan-builder-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "component": "string",
      "action": "string",
      "skuId": {
        "type": "number",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "feature-table-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-expand-section",
        "clicked-expand-table",
        "clicked-collapse-section",
        "clicked-collapse-table"
      ],
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "currentPlan": {
        "type": "string",
        "isOptional": true
      },
      "recommendedPlan": {
        "type": "string",
        "isOptional": true
      },
      "showRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "signup-button-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "trackingSource": "string",
      "signupType": {
        "type": [
          "marketing",
          "sales",
          "service",
          "cms-free",
          "commerce",
          "crm"
        ],
        "isOptional": false
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "trial-button-click": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "trackingSource": "string",
      "upgradeProduct": {
        "type": "string",
        "isOptional": true
      },
      "formattedExperimentArray": {
        "type": "array",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "tooltip-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "name": {
        "type": "string",
        "isOptional": false
      },
      "trackingSource": {
        "type": "string",
        "isOptional": false
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "video-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "name": {
        "type": "string",
        "isOptional": false
      },
      "trackingSource": {
        "type": "string",
        "isOptional": false
      },
      "videoTimestamp": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "buyAdditionalContacts": {
    "name": "buy-additional-contacts",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "productNames": "array",
      "skuIds": "array",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "buyClick": {
    "name": "buy-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productNames": "array",
      "skuIds": "array",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "upgradeProduct": {
        "type": "string"
      },
      "bundledOffer": {
        "type": "string",
        "isOptional": true
      },
      "merchandiseId": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "signupClick": {
    "name": "signup-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "signupType": {
        "type": [
          "crm",
          "marketing",
          "sales",
          "service",
          "cms-free",
          "commerce"
        ]
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "talkToSales": {
    "name": "talk-to-sales-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productName": "string",
      "skuId": "number",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthprofessional",
          "growthenterprise",
          "bundle",
          "marketingstartercms",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "upgradeProduct": {
        "type": "string"
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isHubSpotter": {
        "type": "boolean",
        "isOptional": true
      },
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "ownedProducts": {
        "type": "array",
        "isOptional": true
      },
      "flow": {
        "type": "string",
        "isOptional": true
      },
      "numUsers": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  }
};